import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/system";
import ForecastTabs from "./ForeCasterDiscussionTabs/ForeCasteTabs";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";
import { forecastersEndPointLogic } from "../../../../../logic/AssetManagement/Forecasters/forecastersEndPointLogic";


const ForeCastDiscussion = () =>{
  const oauthTokenHeader = useSelector(selectUserToken) as string;
  const getUserList = async (oauthTokenHeader: string) => { await forecastersEndPointLogic.getAllUserList(oauthTokenHeader);};
  
  //-- Get All Users
    useEffect(() => {
      if(!oauthTokenHeader) return;
      getUserList(oauthTokenHeader);
    }, [oauthTokenHeader]);

  return (
    <Box mt={2} mb={2}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          sx={{ minHeight: "48px !important" }}
        >
          <Typography component="span" sx={{fontSize:"18px"}}>Discussion</Typography>
        </AccordionSummary>
        <AccordionDetails>
         <ForecastTabs />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default ForeCastDiscussion;
